var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05398 13.6666C9.38368 13.6666 12.108 10.6666 12.108 6.99998C12.108 3.33331 9.38368 0.333313 6.05398 0.333313C2.72429 0.333313 0 3.33331 0 6.99998C0 10.6666 2.72429 13.6666 6.05398 13.6666Z",
    fill: "#00CC39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77818 5L5.14579 10L3.32959 8.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIcon);
export default __webpack_public_path__ + "static/media/CompletedIcon.d933e45bcd0d662d85c2fa8c4b6b214d.svg";
export { ForwardRef as ReactComponent };